class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.config = {
      autorotate: this.dataset.autorotate === 'true',
      autorotateSpeed: parseInt(this.dataset.autorotateSpeed) * 1000,
      moveTime: parseFloat(this.dataset.speed),
      space: 100,
    };

    if (theme.config.mqlSmall) {
      this.initOnMobile();
    } else {
      this.initOnDesktop();
    }

    document.addEventListener('matchSmall', () => {
      this.unload();
      this.initOnMobile();
    });

    document.addEventListener('unmatchSmall', () => {
      this.unload();
      this.initOnDesktop();
    });
  }

  initOnDesktop() {
    if (this.dataset.layout === 'carousel') {
      this.initCarousel();
      return;
    }

    this.initMarquee();
  }

  initOnMobile() {
    if (this.dataset.mobileLayout === 'carousel' && this.dataset.forceMarquee !== 'true') {
      this.initMarquee();
      return;
    }

    this.initMarquee();
  }

  unload() {
    if (this.flickity && typeof this.flickity.destroy === 'function') {
      this.flickity.destroy();
      this.removeNextPrevListeners();
      this.flickity = null;
    }

    this.classList.remove('marquee', 'marquee--paused');
    this.querySelectorAll('.announcement-slider[aria-hidden="true"]').forEach((slider) => slider.remove());
    this.isAnimated = false;

    if (this.observer && typeof this.observer.disconnect === 'function') {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  initCarousel() {
    if (this.dataset.blockCount == 1) return;

    const slider = this.querySelector('.announcement-slider');
    setTimeout(() => {
      this.flickity = new Flickity(slider, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        setGallerySize: false,
        autoPlay: this.config.autorotate ? this.config.autorotateSpeed : false,
      });
    });

    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.onNextPrevClick = this.handleNextPrevClick.bind(this);
    this.prevButton && this.prevButton.addEventListener('click', this.onNextPrevClick);
    this.nextButton && this.nextButton.addEventListener('click', this.onNextPrevClick);
  }

  removeNextPrevListeners() {
    this.prevButton && this.prevButton.removeEventListener('click', this.onNextPrevClick);
    this.nextButton && this.nextButton.removeEventListener('click', this.onNextPrevClick);
  }

  handleNextPrevClick(event) {
    event.preventDefault();
    const target = event.currentTarget;

    if (target.name === 'next') {
      this.flickity && this.flickity.next();
    } else if (target.name === 'previous') {
      this.flickity && this.flickity.previous();
    }
  }

  initMarquee() {
    requestAnimationFrame(() => {
      const slider = this.querySelector('.announcement-slider');
      if (!slider) return;

      this.querySelectorAll('.announcement-slider[aria-hidden="true"]').forEach((clone) => clone.remove());

      const sliderWidth = Math.max(slider.scrollWidth, slider.getBoundingClientRect().width, 1);
      const viewportWidth = Math.max(this.getBoundingClientRect().width, window.innerWidth, 1);
      const cloneCount = Math.max(3, Math.ceil((viewportWidth * 2) / sliderWidth) + 2);

      for (let index = 0; index < cloneCount; index++) {
        const clone = slider.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        this.appendChild(clone);
      }

      this.classList.add('marquee');
      const duration = Math.max(8, (sliderWidth / this.config.space) * this.config.moveTime);
      this.style.setProperty('--duration', `${duration}s`);
      this.isAnimated = true;
    });

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.classList.remove('marquee--paused');
        } else {
          this.classList.add('marquee--paused');
        }
      });
    }, { rootMargin: '0px 0px 50px 0px' });

    this.observer.observe(this);
  }
}

customElements.define('announcement-bar', AnnouncementBar);
